import DeviceUsageModal from './device-usage-cpu-modal.connect'

export default DeviceUsageModal
